import React from 'react';
import PropTypes from 'prop-types';

import classes from './ListItemTR.css';

const listItemTR = props => {
  const { title, value,country='',language='' } = props;
  let finalURL;
  if(country!=='' && language!=='')
  {
    if(title === "Dual Element Time Delay Fuse - Amps" || title === "PowerPact MCP Size (Amps)"
    || title === "Max Class J Fuse for IEC contactor - AMPS" || title === "Max Class CC Fuse for IEC contactor - AMPS"
    || title === "Max Class J Fuse for NEMA contactor - AMPS" || title === "Max Class CC Fuse for NEMA contactor - AMPS")
    {
      finalURL = '#';
    }
    else
    {
      /* JK EDIT Set the condition for routing the N Contactor items to a range page.
         The part number in the calculator is not complete and needs a suffix. */
      if(title === "NEMA Sized TeSys N Contactor" || title === "Contacteur NEMA TeSys N") {
        finalURL = `https://www.se.com/${(country==='USA')?'us':'ca'}/${language}/product-range/62155-tesys-n-contactors/`;
      }
      /* JK EDIT Set the condition for routing the D Contactor items to a range page.
         The part number in the calculator is not complete and needs a suffix. */
      else {
        if(title === "IEC Contactor TeSys D & F" || title === "Contacteur IEC TeSys D & F") {
          finalURL = `https://www.se.com/${(country==='USA')?'us':'ca'}/${language}/product-range/664-tesys-d/`;
      }

      /* JK EDIT Set the URL to go to the product page. */
      else {
       finalURL = `https://www.se.com/${(country==='USA')?'us':'ca'}/${language}/product/${value}`;
      }
    }
    }
  }
  else
  {
    finalURL = '#';
  }
  
  return (
    <li className={classes.ListItemTR}>
      <p>{title}</p>
      <p>
      {
        (value  === '-' || finalURL === '#') ? 
        (<span>{value}</span>) : 
        (<a className={classes.removeHrefProperty} href={finalURL} target="_blank" rel="noopener noreferrer"> {value} </a>) 
      }
      </p>
    </li>
  );
};

listItemTR.propTypes = {
  title: PropTypes.string
};

export default listItemTR;
